import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./hooks/useCart";
import type { CartItem } from "./hooks/useCart";
import { FavoritesProvider } from "./hooks/useFavorites";
import type { FavoriteItem } from "./hooks/useFavorites";
import CartDrawer from "./components/feature/CartDrawer";
import ScrollToTop from "./components/feature/ScrollToTop";
import { ToastProvider, useToast } from "./hooks/useToast";
import { usePromoExpiryNotifier } from "./hooks/usePromoExpiryNotifier";
import PromoExpiryBanner from "./components/feature/PromoExpiryBanner";

/* Inner component so it can access ToastProvider context */
const AppInner = () => {
  const { showToast } = useToast();
  usePromoExpiryNotifier();

  const handleItemAdded = (item: Omit<CartItem, 'quantity'>, isNew: boolean) => {
    showToast({
      type: 'cart',
      title: isNew ? 'Добавлено в корзину' : 'Количество увеличено',
      message: item.name,
      image: item.image,
      color: item.color,
      price: item.price,
    });
  };

  const handleFavoriteToggle = (item: Omit<FavoriteItem, 'addedAt'>, added: boolean) => {
    showToast(
      added
        ? {
            type: 'favorite',
            title: 'Добавлено в избранное',
            message: item.name,
            image: item.image,
            color: '#ff2d78',
            price: item.price,
          }
        : {
            type: 'favorite_remove',
            title: 'Удалено из избранного',
            message: item.name,
            image: item.image,
            color: 'rgba(255,255,255,0.35)',
          }
    );
  };

  return (
    <CartProvider onItemAdded={handleItemAdded}>
      <FavoritesProvider onToggle={handleFavoriteToggle}>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
          <CartDrawer />
          <ScrollToTop />
          <PromoExpiryBanner />
        </BrowserRouter>
      </FavoritesProvider>
    </CartProvider>
  );
};

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ToastProvider>
        <AppInner />
      </ToastProvider>
    </I18nextProvider>
  );
}

export default App;
